/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Prize_EmptyInputs */



/**
* | output |
* | --- |
* | "No promos configured" |
*
* @param {Raffle_Prize_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_prize_empty = /** @type {((inputs?: Raffle_Prize_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Prize_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune promo configurée")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay promos configuradas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma promo configurada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna promo configurata")
	return /** @type {LocalizedString} */ ("No promos configured")
});